module.exports = __webpack_public_path__ + "img/task-management.fbd2b8c.jpg";